import SectionHeading from '@/components/base/SectionHeading';
import { AWARDS } from '@/mocks/schedule';

export default function AwardsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="awards-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="awards-heading"
          eyebrow="Awards"
          title="六个奖项，名次与单项分开评"
          desc="金银铜奖由决赛综合成绩决定，三个单项奖由评审团与公开投票分别产生，避免只看票数。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {AWARDS.map((a, idx) => (
            <article
              key={a.name}
              className={`flex flex-col rounded-lg border p-6 ${
                idx < 3 ? 'border-primary-200 bg-primary-50' : 'border-background-200 bg-background-100'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-trophy-line text-lg"></i>
                </span>
                <span className="text-xs text-foreground-500">{a.quota}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{a.name}</h3>
              <p className="mt-2 text-sm font-medium text-primary-700">{a.prize}</p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{a.note}</p>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs md:text-sm text-foreground-500">
          奖金与扶持名额的具体发放安排会在颁奖盛典后通过站内信通知，赛事不收取任何报名费用。
        </p>
      </div>
    </section>
  );
}